import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  aDate: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
  categoryId: [
    validator('belongs-to'),
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
  headline: validator('presence', true),
  text: validator('presence', true),
});

export const settings = {
  copyableOptions: {
    ignoreAttributes: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
    ],
  },
  variantProperties: [
    'cmsLanguageId',
    'seoTitle',
    'seoDescription',
    'keywords',
    'seoImage',
    'cmsState',
    'headline',
    'subHeadline',
    'teaserHeadline',
    'teaserSubHeadline',
    'teaserText',
    'text',
    'variantChannel',
  ],
};

export default class ArticleModel extends Model.extend(Validations) {
  @attr aDate;
  @attr('string') entitySubtype;
  @attr('string') headline;
  @attr('string') subHeadline;
  @attr('boolean', { defaultValue: 1 }) showDate;
  @attr('boolean') showMore;
  @attr('string') teaserHeadline;
  @attr('string') teaserSubHeadline;
  @attr('string') teaserText;
  @attr('string') text;

  // Variants
  @belongsTo('channel', { async: true, inverse: null }) variantChannel;

  // CMS fields
  @attr cmsKilldate;
  @attr cmsLivedate;
  @attr('string') seoTitle;
  @attr('string') seoDescription;
  @attr('string') keywords;
  @attr('number', { defaultValue: 1 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('artist', { async: true, inverse: null }) artists;
  @belongsTo('asset', { async: true, inverse: null }) assetId;
  @hasMany('asset', { async: true, inverse: null }) assets;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @belongsTo('category', { async: true, inverse: null }) categoryId;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;
  @hasMany('asset', { async: true, inverse: null }) documents;
  @belongsTo('link', { async: true, inverse: null }) linkId;
  @hasMany('link', { async: true, inverse: null }) links;
  @belongsTo('media-embed', { async: true, inverse: null }) mediaEmbed;
  @belongsTo('channel', { async: true, inverse: null }) ownedByChannel;
  @hasMany('product', { async: true, inverse: null }) products;
  @hasMany('article', { async: true, inverse: null }) recommendedArticles;
  @hasMany('taxon', { async: true, inverse: null }) taxa;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return `${this.headline} (${this.id})`;
  }
}
